import PropTypes from 'prop-types';

export const productShape = PropTypes.shape({
  orderLineKey: PropTypes.string.isRequired,
  primeLineKey: PropTypes.string,
  productId: PropTypes.string,
  collection: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  imageId: PropTypes.string,
  partNumber: PropTypes.string,
  name: PropTypes.string,
  finalSaleItem: PropTypes.bool,
  returnable: PropTypes.bool,
  returnDetails: PropTypes.shape({
    returnOrderNumber: PropTypes.string,
  }),
  bucket: PropTypes.string,
});

export default PropTypes.arrayOf(productShape);
